export const getInternalReports = state => state.internalReport.internalReportsList;
export const getInternalReportDetails = state => state.internalReport.internalReportDetails;
